export default __webpack_public_path__ + "static/media/icon_check_yes.008019c6.svg";